module.exports = __webpack_public_path__ + "img/planting_05.e948e0b.jpg";